import { patchSangjoQuotationRequestAcceptNightCall } from "@/apis/sangjoQuotation";
import { useRouter } from "next/router";
import { useMutation } from "react-query";

export const usePatchSangjoQuotationRequestAcceptNightCall = (
  id: string,
  acceptNightCall: boolean,
) => {
  const router = useRouter();

  return useMutation(() => patchSangjoQuotationRequestAcceptNightCall(id, acceptNightCall), {
    onSuccess: (res) => {
      if (res?.data?.first_quotation) {
        router.replace(`/match/recommendation/${res.data.first_quotation}`);
      } else {
        router.replace(`/match/recommendations/`);
      }
    },
    onError: () => router.replace("/match/recommendations/"),
  });
};
